import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import HighlightText from './HighlightText';
import { locations } from '../data/locationsData';

const { FiMapPin } = FiIcons;

const AreaChip = ({ area }) => (
  <Link
    to={`/location/${area.slug}`}
    className="flex items-center gap-2 px-3 py-3 border transition-colors bg-red-50 border-red-100 hover:border-primary hover:bg-primary hover:text-white group"
  >
    <FiMapPin className="w-4 h-4 flex-shrink-0 text-primary group-hover:text-white transition-colors" />
    <span className="text-sm font-bold text-slate-700 group-hover:text-white transition-colors">{area.label}</span>
  </Link>
);

const AreasAndProcess = () => (
  <section className="py-20 bg-[#fdf8f4]" id="about">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="bg-white p-8 border border-gray-100 shadow-sm">
        {/* Header */}
        <div className="flex items-center gap-4 mb-8">
          <div className="w-12 h-12 bg-red-50 flex items-center justify-center">
            <FiMapPin className="text-primary w-6 h-6" />
          </div>
          <div>
            <h2 className="text-2xl font-extrabold text-slate-900 tracking-tight">
              Areas We <HighlightText>Cover</HighlightText>
            </h2>
            <p className="text-sm text-gray-500 font-medium mt-1">
              Click on any area to find tutors near you
            </p>
          </div>
        </div>

        {/* All Areas Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
          {locations.map((area, idx) => (
            <AreaChip key={idx} area={area} />
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default AreasAndProcess;